import React from 'react';
import { Tabs } from '../../ui';
import { Basic } from './basic';

const BASIC = 'basic';
const ADVANCED = 'advanced';

const TABS = [
  {
    id: BASIC,
    label: 'Basic',
    component: () => <Basic />,
  },
  {
    id: ADVANCED,
    label: 'Advanced',
    component: () => <h2>Coming soon!</h2>,
  },
];

export const ReportsModal = ({ back }) => (
  <Tabs tabs={TABS} initialState={BASIC} additionalProps={{ back }} />
);
